/**
 * Do not edit directly
 * Generated on Sun, 23 Jun 2019 15:43:43 GMT
 */

export const N0: string = '#FFFFFF';
export const N10: string = '#FAFBFC';
export const N20: string = '#F4F5F7';
export const N30: string = '#EBECF0';
export const N40: string = '#DFE1E6';
export const N50: string = '#C1C7D0';
export const N60: string = '#B3BAC5';
export const N70: string = '#A5ADBA';
export const N80: string = '#97A0AF';
export const N90: string = '#8993A4';
export const N100: string = '#7A869A';
export const N200: string = '#6B778C';
export const N300: string = '#5E6C84';
export const N400: string = '#505F79';
export const N500: string = '#42526E';
export const N600: string = '#344563';
export const N700: string = '#253858';
export const N800: string = '#172B4D';
export const N900: string = '#091E42';
export const N10A: string = 'rgba(9,30,66, 2%)';
export const N20A: string = 'rgba(9,30,66, 4%)';
export const N30A: string = 'rgba(9,30,66, 8%)';
export const N40A: string = 'rgba(9,30,66, 13%)';
export const N50A: string = 'rgba(9,30,66, 25%)';
export const N60A: string = 'rgba(9,30,66, 31%)';
export const N70A: string = 'rgba(9,30,66, 36%)';
export const N80A: string = 'rgba(9,30,66, 42%)';
export const N90A: string = 'rgba(9,30,66, 48%)';
export const N100A: string = 'rgba(9,30,66, 54%)';
export const N200A: string = 'rgba(9,30,66, 60%)';
export const N300A: string = 'rgba(9,30,66, 66%)';
export const N400A: string = 'rgba(9,30,66, 71%)';
export const N500A: string = 'rgba(9,30,66, 77%)';
export const N600A: string = 'rgba(9,30,66, 82%)';
export const N700A: string = 'rgba(9,30,66, 89%)';
export const N800A: string = 'rgba(9,30,66, 95%)';
export const TrelloBlue25: string = '#F7FCFE';
export const TrelloBlue50: string = '#E4F0F6';
export const TrelloBlue100: string = '#BCD9EA';
export const TrelloBlue200: string = '#8BBDD9';
export const TrelloBlue300: string = '#5BA4CF';
export const TrelloBlue400: string = '#298FCA';
export const TrelloBlue500: string = '#0079BF';
export const TrelloBlue600: string = '#026AA7';
export const TrelloBlue700: string = '#055A8C';
export const TrelloBlue800: string = '#094C72';
export const TrelloBlue900: string = '#0C3953';
export const Green50: string = '#EEF6EC';
export const Green100: string = '#D6ECD2';
export const Green200: string = '#B7DDB0';
export const Green300: string = '#99D18F';
export const Green400: string = '#7BC86C';
export const Green500: string = '#61BD4F';
export const Green600: string = '#5AAC44';
export const Green700: string = '#519839';
export const Green800: string = '#49852E';
export const Green900: string = '#3F6F21';
export const Orange50: string = '#FDF4E7';
export const Orange100: string = '#FCE6C6';
export const Orange200: string = '#FAD29C';
export const Orange300: string = '#FDBF69';
export const Orange400: string = '#FFAF3F';
export const Orange500: string = '#FF9F1A';
export const Orange600: string = '#E79217';
export const Orange700: string = '#CD8313';
export const Orange800: string = '#B4760F';
export const Orange900: string = '#96650A';
export const Red50: string = '#FBEDEB';
export const Red100: string = '#F5D3CE';
export const Red200: string = '#EFB3AB';
export const Red300: string = '#EC9488';
export const Red400: string = '#EF7564';
export const Red500: string = '#EB5A46';
export const Red600: string = '#CF513D';
export const Red700: string = '#B04632';
export const Red800: string = '#933B27';
export const Red900: string = '#6E2F1A';
export const Yellow50: string = '#FDFAE5';
export const Yellow100: string = '#FAF3C0';
export const Yellow200: string = '#F5EA92';
export const Yellow300: string = '#F3E260';
export const Yellow400: string = '#F5DD29';
export const Yellow500: string = '#F2D600';
export const Yellow600: string = '#E6C60D';
export const Yellow700: string = '#D9B51C';
export const Yellow800: string = '#CCA42B';
export const Yellow900: string = '#BD903C';
export const Purple50: string = '#F7F0FA';
export const Purple100: string = '#EDDBF4';
export const Purple200: string = '#DFC0EB';
export const Purple300: string = '#D5A6E6';
export const Purple400: string = '#CD8DE5';
export const Purple500: string = '#C377E0';
export const Purple600: string = '#A86CC1';
export const Purple700: string = '#89609E';
export const Purple800: string = '#6C547B';
export const Purple900: string = '#484553';
export const Pink50: string = '#FEF1F9';
export const Pink100: string = '#FCDCEF';
export const Pink200: string = '#F9C2E4';
export const Pink300: string = '#FFABDF';
export const Pink400: string = '#FF8ED4';
export const Pink500: string = '#FF78CB';
export const Pink600: string = '#E568AF';
export const Pink700: string = '#C9558F';
export const Pink800: string = '#AE4270';
export const Pink900: string = '#8E2D4B';
export const Sky25: string = '#E6F0F5';
export const Sky50: string = '#E4F7FA';
export const Sky100: string = '#BDECF3';
export const Sky200: string = '#8FDFEB';
export const Sky300: string = '#5DD3E5';
export const Sky400: string = '#29CCE5';
export const Sky500: string = '#00C2E0';
export const Sky600: string = '#00AECC';
export const Sky700: string = '#0098B7';
export const Sky800: string = '#0082A0';
export const Sky900: string = '#006988';
export const Lime50: string = '#ECFBF3';
export const Lime100: string = '#D3F6E4';
export const Lime200: string = '#B3F1D0';
export const Lime300: string = '#90ECC1';
export const Lime400: string = '#6DECA9';
export const Lime500: string = '#51E898';
export const Lime600: string = '#4ED583';
export const Lime700: string = '#4BBF6B';
export const Lime800: string = '#49AA54';
export const Lime900: string = '#459139';
export const BusinessBlue50: string = '#EDEFF4';
export const BusinessBlue100: string = '#D2D7E5';
export const BusinessBlue200: string = '#B2B9D0';
export const BusinessBlue300: string = '#838FB5';
export const BusinessBlue400: string = '#6170A1';
export const BusinessBlue500: string = '#42548E';
export const BusinessBlue600: string = '#3E4D80';
export const BusinessBlue700: string = '#3A476F';
export const BusinessBlue800: string = '#36405F';
export const BusinessBlue900: string = '#30364C';
export const Opacity1: string = 'rgba(255, 255, 255, 0.1)';
export const Opacity2: string = 'rgba(255, 255, 255, 0.2)';
export const Opacity3: string = 'rgba(255, 255, 255, 0.3)';
export const Opacity4: string = 'rgba(255, 255, 255, 0.4)';
export const Opacity5: string = 'rgba(255, 255, 255, 0.5)';
export const Opacity6: string = 'rgba(255, 255, 255, 0.6)';
export const Opacity7: string = 'rgba(255, 255, 255, 0.7)';
export const Opacity8: string = 'rgba(255, 255, 255, 0.8)';
export const Opacity9: string = 'rgba(255, 255, 255, 0.9)';
export const OpacityDark1: string = 'rgba(0, 0, 0, 0.1)';
export const OpacityDark2: string = 'rgba(0, 0, 0, 0.2)';
export const OpacityDark3: string = 'rgba(0, 0, 0, 0.3)';
export const OpacityDark4: string = 'rgba(0, 0, 0, 0.4)';
export const OpacityDark5: string = 'rgba(0, 0, 0, 0.5)';
export const OpacityDark6: string = 'rgba(0, 0, 0, 0.6)';
export const OpacityDark7: string = 'rgba(0, 0, 0, 0.7)';
export const OpacityDark8: string = 'rgba(0, 0, 0, 0.8)';
export const OpacityDark9: string = 'rgba(0, 0, 0, 0.9)';
export const Black: string = '#000000';
